module.exports = __webpack_public_path__ + "static/img/11.2d23f71.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/1/11.jpg
// module id = 723
// module chunks = 0